// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay{max-height:30px;padding:2px;margin:5px;border-radius:3px}.white-bg{background-color:#fff}", ""]);
// Exports
module.exports = exports;
